exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#card-element {\n  padding: 10px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 5px;\n  margin-top: 15px;\n  margin-bottom: 30px;\n}\n.loading-spinner {\n  border: 5px solid #53AF31;\n  border-top: 5px solid transparent;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1.2s linear infinite;\n  margin-top: 15px;\n  margin-bottom: 30px;\n}\n@keyframes spin {\n0% { transform: rotate(0deg);\n}\n100% { transform: rotate(360deg);\n}\n}\n", ""]);

// exports
